import { Box, IconButton } from "@material-ui/core";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import dayjs from "dayjs";
import { FC } from "react";

import CancelingReason from "../../../../../components/CancelingReason";
import CustomModal from "../../../../../components/CustomModal";
import TooltipPopover from "../../../../../components/TooltipPopover";
import useCurrentUser from "../../../../../hooks/useCurrentUser";
import useOnUpdateRecord from "../../../../../hooks/useOnUpdateRecord";
import colors from "../../../../../theme/colors";
import { AppResource } from "../../../../../types/resource.types";
import { coachReservationDocRef, coachDocRef } from "../../../../../utils/referencies";
import { applyUpdateTimestamp } from "../../../../../utils/timestamp";
import { ReservationStatus } from "../../types";
import { isEndingWithin24Hours } from "../../utils";

const CancelReservation: FC<any> = (props) => {
  const reservation = props.record;
  const status: ReservationStatus = reservation.status;
  const { user } = useCurrentUser();

  const isReservationBeforeToday = (reservationTime: Date): boolean => dayjs(reservationTime).isBefore(dayjs());

  const onUpdateRecord = useOnUpdateRecord(
    AppResource.coachReservations,
    "Reservation has been canceled",
    "Error on cancel reservation"
  );

  const handleRejectRecord = async (cancellationReason: string) => {
    await onUpdateRecord(async () => {
      await coachReservationDocRef(reservation.id).update(
        applyUpdateTimestamp({
          status: ReservationStatus.canceled,
          cancellationReason,
          canceledBy: coachDocRef(user.id as string),
        })
      );
    });
  };

  const ActionIcon = (
    <TooltipPopover
      message={
        isEndingWithin24Hours(reservation?.firstSlotTime?.toDate())
          ? "Starting within 24 hours, you can't cancel it"
          : "Cancel Reservation"
      }
    >
      <IconButton>
        <HighlightOffIcon style={{ color: colors.error.main }} />
      </IconButton>
    </TooltipPopover>
  );

  return (
    <>
      {!isReservationBeforeToday(reservation?.firstSlotTime?.toDate()) ? (
        <>
          {status === ReservationStatus.confirmed ? (
            <>
              {!isEndingWithin24Hours(reservation?.firstSlotTime?.toDate()) ? (
                <Box display="flex" alignItems="center">
                  <CustomModal ModalOpenButton={ActionIcon}>
                    {(modalProps: any) => {
                      return (
                        <CancelingReason
                          handleCloseModal={modalProps.handleCloseModal}
                          onRejectRecord={handleRejectRecord}
                        />
                      );
                    }}
                  </CustomModal>
                </Box>
              ) : isEndingWithin24Hours(reservation?.firstSlotTime?.toDate()) ? (
                ActionIcon
              ) : null}
            </>
          ) : null}
        </>
      ) : null}
    </>
  );
};

export default CancelReservation;
